module.exports = __webpack_public_path__ + "img/tab04.c007ceaa.jpg";